import { useEffect, useState } from "react";
import GroupUserPermissions from "components/permission/GroupUserPermissions";
import { useForm } from "hooks/useForm";
import { Grid } from "@material-ui/core";
import PermissionSettingsConfig from "components/permission/PermissionSettingsConfig";
import LabMasterService from "services/admin/masters/LabService";

const labServiceObject = new LabMasterService();
export default function PermissionTab(props) {
    const { labDetails, bindGeneralInfo } = props;
    const { user_permissions, group_permissions } = labDetails;
    const [permissionConfig, setPermissionConfig] = useState({});
    let selectedUsers = [];
    let selectedGroups = [];
    user_permissions && user_permissions.length > 0 && user_permissions.forEach(element => {
        selectedUsers.push(element.user_id);
    });

    group_permissions && group_permissions.length > 0 && group_permissions.forEach(element => {
        selectedGroups.push(element.group_id);
    })
    const [groupUserList, setGroupUserList] = useState([]);
    const initialFormData = {
        users: selectedUsers || [],
        groups: selectedGroups || [],
    };
    useEffect(() => {
        labServiceObject.getAllGroupsWithUsers().then(response => {
            setGroupUserList(response)
        }).catch(err => {
            console.log('error in group user data')
        })
        if (user_permissions && user_permissions.length > 0 && user_permissions[0].id) {
            labServiceObject.getPermissionUserConfiguration(user_permissions[0].id).then(response => {
                if (response) {
                    setPermissionConfig(response);
                    bindLocalStorageData(response);
                }
            })
        }
        if (group_permissions && group_permissions.length > 0 && group_permissions[0].id) {
            labServiceObject.getPermissionGroupConfiguration(group_permissions[0].id).then(response => {
                if (response) {
                    setPermissionConfig(response);
                    bindLocalStorageData(response);
                }
            })
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        initialFormData.users = selectedUsers || []
        initialFormData.groups = selectedGroups || []
        populateForm(initialFormData);
        // eslint-disable-next-line
    }, [])

    const bindLocalStorageData = (response) => {
        bindGeneralInfo("max_time" ,response.max_time);
        bindGeneralInfo("extension_time", response.extension_time);
        bindGeneralInfo("max_extension", response.max_extension);
    }

    const { handleMultipleChange, data, populateForm } = useForm({
        initialValues: initialFormData,
        validations: {
            groups: {
                required: {
                    value: true,
                    message: 'Atleast 1 group need to select',
                }
            },
        },
    });

    const handleChange = (data) => {
        handleMultipleChange(data);
        data.forEach(element => {
            if (element.key === 'groups')
                bindGeneralInfo('groups_permission', element.targetValue)
            else
                bindGeneralInfo('users_permission', element.targetValue)
        });
    }
    return (
        <><Grid item xs={12} style={{ display: 'flex' }}>
            <Grid item xs={8} >
                <GroupUserPermissions selectedData={{ groups: data?.groups, users: data?.users }} changeHandler={handleChange} data={groupUserList} />
            </Grid>
            <Grid item xs={4} >
                <PermissionSettingsConfig permissionConfig={permissionConfig} bindGeneralInfo={bindGeneralInfo} />
            </Grid>
        </Grid>
        </>
    )
}